import { all } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { isRequired } from '@gef-ui/form-core/validations/validationFunctions/common';
import { getLabelMessage } from '@gef-ui/localization/messages';

import isBirthNumberOrBusinessIn from 'app/forms/validations/isBirthNumberOrBusinessIn';
import isBusinessCaseNo from 'app/forms/validations/isBusinessCaseNo';
import isBusinessName from 'app/forms/validations/isBusinessName';
import isFirstName from 'app/forms/validations/isFirstName';
import isNumber from 'app/forms/validations/isNumber';
import isPolicyNo from 'app/forms/validations/isPolicyNo';
import isSurname from 'app/forms/validations/isSurname';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME = 'producedProductionNew-modal';

const { sellerIn, businessName, surname, firstName, personIn, documentType, policyNumber } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	businessName,
	firstName,
	surname,
	personIn,
	sellerIn,
	documentType,
	policyNumber,
	scannedDocument: 'scannedDocument',
	text: 'text',
	businessCaseNo: 'businessCaseNo',
};

export default () => ({
	[FIELDS.businessName]: {
		deepPath: [FIELDS.businessName],
		validations: [
			isRequired({
				when: ({ formData }) => all(isNilOrEmpty)([formData?.firstName, formData?.surname]),
			}),
			isBusinessName(),
		],
	},
	[FIELDS.firstName]: {
		deepPath: [FIELDS.firstName],
		validations: [
			isRequired({
				when: ({ formData }) => isNilOrEmpty(formData?.businessName),
			}),
			isFirstName(),
		],
	},
	[FIELDS.surname]: {
		deepPath: [FIELDS.surname],
		validations: [
			isRequired({
				when: ({ formData }) => isNilOrEmpty(formData?.businessName),
			}),
			isSurname(),
		],
	},
	[FIELDS.sellerIn]: {
		deepPath: [FIELDS.sellerIn],
		validations: [],
	},
	[FIELDS.personIn]: {
		deepPath: [FIELDS.personIn],
		validations: [
			isRequired({
				when: ({ formData }) => formData?.documentType === 'B',
			}),
			isBirthNumberOrBusinessIn(),
		],
	},

	[FIELDS.documentType]: {
		deepPath: [FIELDS.documentType],
		validations: [isRequired()],
	},
	[FIELDS.policyNumber]: {
		deepPath: [FIELDS.policyNumber],
		validations: [isNumber({ customMessage: getLabelMessage('validation:allowedCharacters') }), isPolicyNo()],
	},
	[FIELDS.scannedDocument]: {
		deepPath: [FIELDS.scannedDocument],
		validations: [],
	},
	[FIELDS.text]: {
		deepPath: [FIELDS.text],
		validations: [isRequired()],
	},
	[FIELDS.businessCaseNo]: {
		deepPath: [FIELDS.businessCaseNo],
		validations: [
			isRequired({
				when: ({ formData }) => formData?.documentType === 'M',
			}),
			isBusinessCaseNo(),
		],
	},
});
